module.exports = __webpack_public_path__ + "static/media/process-partner-2.e1e26f0f.png";